// today
const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

// 30 days after
const maxDateNow = () => {
  let beforedate = new Date()
  let priordate = new Date()
  priordate.setDate(beforedate.getDate() + 7)
  let dd2 = priordate.getDate()
  let mm2 = priordate.getMonth() + 1
  let yyyy2 = priordate.getFullYear()
  if (dd2 < 10) { dd2 = '0' + dd2 };
  if (mm2 < 10) { mm2 = '0' + mm2 };
  let datefrommonthago = yyyy2 + '-' + mm2 + '-' + dd2

  return datefrommonthago
}

export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  garages: [],
  parking: {
    plate: null,
    model: null,
    color: null,
    tower_id: null,
    unit_id: null,
    garage_id: null,
    guest_name: null,
    destination_tower_id: null,
    destination_unit_id: null,
    date_go_in: null,
    date_go_out: null,
    status: true,
    terms: true,
    garage_number_visitor: null
  },
  parkings: [],
  entity: 'parking',
  entities: 'parkings',
  dwellerUnits: [],
  dwellerTowers: [],
  optionUnits: [],
  optionTowers: [],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  visitorGarages: [
    {
      id: '49',
      label: '49'
    },
    {
      id: '50',
      label: '50'
    },
    {
      id: '51',
      label: '51'
    },
    {
      id: '52',
      label: '52'
    }
  ],
  miniDate: minDateNow(),
  maxDate: maxDateNow(),
  prefixRouter: 'dweller.parking'
})



// WEBPACK FOOTER //
// ./src/app/tenant/parking/resources/data.js